import React  from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";


export default function FieldEventStatus_ViewSmall(props:FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)


    const label = value ? "Accomplished" : "Pending";
    const color = props.model.isAccomplished ? "11" : "2";

    return (
        <div className={Classes('ui5-status-list', 'status-c{0}'.f(color), props.className)}>
            {label}
        </div>
    );

}
